"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisersService = void 0;
class AdvertisersService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of advertisers.
     * @param page 'Page number (default 1)
     * @param count Number of results per page (default 10)
     * @param q Query to filter the results on
     * @returns AdvertisersResponse
     * @throws ApiError
     */
    getAllAdvertisers(page, count, q) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers',
            query: {
                'page': page,
                'count': count,
                'q': q,
            },
        });
    }
    /**
     * Returns specific account details by id.
     * @param id
     * @returns AdvertiserResponse
     * @throws ApiError
     */
    getAdvertiser(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update an advertiser
     * @param id
     * @param requestBody
     * @returns AdvertiserResponse
     * @throws ApiError
     */
    updateAdvertiser(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/advers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an advertiser
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAdvertiser(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/advers/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns account details by advertiser fields
     * @param requestBody
     * @returns AdvertiserResponse
     * @throws ApiError
     */
    getAdvertiserBy(requestBody) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers-by',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a list of advertisers assets
     * @param advertiserId
     * @param page
     * @param count
     * @returns AdvertiserAssetsResponse
     * @throws ApiError
     */
    getAdvertiserAssets(advertiserId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/{advertiserId}/assets',
            path: {
                'advertiserId': advertiserId,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Create an asset for an advertiser
     * @param advertiserId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    createAdvertiserAsset(advertiserId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/{advertiserId}/assets',
            path: {
                'advertiserId': advertiserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get specific advertisers asset
     * @param advertiserId
     * @param id
     * @returns AdvertiserAssetResponse
     * @throws ApiError
     */
    getAdvertiserAsset(advertiserId, id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/{advertiserId}/assets/{id}',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
        });
    }
    /**
     * Update an asset of an advertiser
     * @param advertiserId
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateAdvertiserAsset(advertiserId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/advers/{advertiserId}/assets/{id}',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete an asset for an advertiser
     * @param advertiserId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAdvertiserAsset(advertiserId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/advers/{advertiserId}/assets/{id}',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
        });
    }
    /**
     * Create an asset upload url for an offering
     * @param advertiserId
     * @param requestBody
     * @returns GetFileSignedUrlResponse
     * @throws ApiError
     */
    createAdvertiserAssetUploadUrl(advertiserId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/{advertiserId}/assets/generate-asset-upload-signed-url',
            path: {
                'advertiserId': advertiserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a list of advertisers workflows
     * @param advertiserId
     * @param page
     * @param count
     * @returns AdvertisersWorkflowInfosResponse
     * @throws ApiError
     */
    getAdvertiserWorkflows(advertiserId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/{advertiserId}/workflows',
            path: {
                'advertiserId': advertiserId,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Create a workflow for an advertiser
     * @param advertiserId
     * @param requestBody
     * @returns AdvertiserWorkflowResponse
     * @throws ApiError
     */
    createAdvertiserWorkflow(advertiserId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/{advertiserId}/workflows',
            path: {
                'advertiserId': advertiserId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a an advertisers workflow
     * @param advertiserId
     * @param id
     * @returns AdvertiserWorkflowResponse
     * @throws ApiError
     */
    getAdvertiserWorkflow(advertiserId, id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/{advertiserId}/workflows/{id}',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
        });
    }
    /**
     * Update a workflow of an advertiser
     * @param advertiserId
     * @param id
     * @param requestBody
     * @returns AdvertiserWorkflowResponse
     * @throws ApiError
     */
    updateAdvertiserWorkflow(advertiserId, id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/advers/{advertiserId}/workflows/{id}',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Add a deliverable to workflow
     * @param advertiserId
     * @param id
     * @param requestBody
     * @returns CampaignDeliverableParam
     * @throws ApiError
     */
    addWorkflowDeliverable(advertiserId, id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/{advertiserId}/workflows/{id}/deliverables',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a workflow for an advertiser
     * @param advertiserId
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAdvertiserWorkflow(advertiserId, id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/advers/{advertiserId}/workflow/{id}',
            path: {
                'advertiserId': advertiserId,
                'id': id,
            },
        });
    }
    /**
     * Set up the attribution for an advertiser
     * @param id
     * @param requestBody
     * @returns AttributionSetupResponse
     * @throws ApiError
     */
    setupAdvertiserAttribution(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/{id}/attribution/setup',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Searches for advertiser integrations
     * @param type
     * @param advertiserId
     * @param page
     * @param count
     * @returns AdvertiserIntegration
     * @throws ApiError
     */
    searchAdvertiserIntegrations(type, advertiserId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advertiserIntegrations',
            query: {
                'type': type,
                'advertiserId': advertiserId,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Returns a list of advertiser integrations
     * @param id
     * @returns AdvertiserIntegration
     * @throws ApiError
     */
    getAdvertiserIntegrations(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/advers/{id}/integrations',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Creates a new advertiser integration
     * @param id
     * @param requestBody
     * @returns AdvertiserIntegration
     * @throws ApiError
     */
    createAdvertiserIntegration(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/{id}/integrations',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Updates an advertiser integration
     * @param id
     * @param integrationId
     * @param requestBody
     * @returns AdvertiserIntegration
     * @throws ApiError
     */
    updateAdvertiserIntegration(id, integrationId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/advers/{id}/integrations/{integrationId}',
            path: {
                'id': id,
                'integrationId': integrationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes an advertiser integration
     * @param id
     * @param integrationId
     * @returns any Successful response
     * @throws ApiError
     */
    deleteAdvertiserIntegration(id, integrationId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/advers/{id}/integrations/{integrationId}',
            path: {
                'id': id,
                'integrationId': integrationId,
            },
        });
    }
    /**
     * Migrate advertiser attribution data from old model to new model
     * @returns any Successful response
     * @throws ApiError
     */
    migrateAdvertiserAttributionData() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/advers/migrate-attribution-data',
        });
    }
}
exports.AdvertisersService = AdvertisersService;
